import React from 'react'
import PropTypes from 'prop-types'
import ChallengeEntry from './challengeEntry'

const ChallengeTable = ({ challenges, cancel}) => (

    <table className="table lobby-table table-hover table-striped match-history">
        <thead>
            <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Status</th>
                <th>Created</th>
                <th>LastUpdated</th>
                <th>ParticipantCount</th>
                <th>RunCount</th>
                <th>Cancel</th>
            </tr>
        </thead>
        <tbody>

            {typeof challenges === 'undefined' ? '' : (challenges.map((challenge, index) => (
                <ChallengeEntry key={challenge.challengeId} {...challenge} index={index} cancel={() => cancel(challenge.id)}  />
            )))}
        </tbody>
    </table>
)

export default ChallengeTable